export { RecentProjectsComponent } from './recent-projects.component';
export { RecentProjectsService } from './recent-projects.service';



// WEBPACK FOOTER //
// ./src/app/shared/layout/header/recent-projects/index.ts